import styled from 'styled-components';

const AvatarContainer = styled.div`
  margin-right: 10px;
`;

export default AvatarContainer;
